export default __webpack_public_path__ + "static/media/moot-court-1.4cf4de40.webp";